import React from 'react'
import { useTranslate, TextInput, NumberInput, ArrayInput, minValue } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import { Dialog, DialogContent, DialogTitle, Grid, DialogActions } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import {useFieldArray, useFormContext  } from 'react-hook-form'

export const CurrencyExchangeModal = ({ open, handleClose, titleModal, paymentExchanges}) => {
  const translate = useTranslate()
  const { control } = useFormContext()
  const { fields } = useFieldArray({ name: "currencies_exchange", control })
  return (
    <Dialog open={open} maxWidth="lg" fullWidth>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {fields.map((item, index) => (
            <Grid container item spacing={2} key={item.id}>
              
              <Grid item xs={4}>
                <TextInput
                  source={`currencies_exchange[${index}].currency_relation.short_name`}
                  disabled
                  label={null}
                  fullWidth
                />
              </Grid>

              <Grid item xs={4}>
                <TextInput
                  source={`currencies_exchange[${index}].currency_to_relation.short_name`}
                  disabled
                  label={null}
                  fullWidth
                />
              </Grid>

              <Grid item xs={4}>
                <NumberInput
                  source={`currencies_exchange[${index}].value`}
                  validate={[minValue(0.000000000000001)]}
                  label={null}
                  fullWidth
                />
              </Grid>

            </Grid>
          ))}
        </Grid>

        <DialogActions style={{ marginTop: "20px" }}>
          <LoadingButton
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleClose}
          >
            {translate("ra.action.save")}
          </LoadingButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}